
import extend from '@/utils/vuex-extend';
import { table } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import { fetchList, carryOutDemandPlan } from '@/api/pcm/plan';
import { Message } from 'element-ui';

export default extend(table, {
    namespaced: true,
    state: {
        searchForm: {},
        multipleSelection: []
    },
    actions: {
        async getList({ state, dispatch }, payload) {
			await wait(dispatch, 'pcm.purchase.list', async function() {
                const { searchForm } = state;
				await dispatch('getData', {
					caller: fetchList,
					options: {
						...searchForm,
						...payload
					}
				});
            })
        },
		async carryOutDemandPlan({ state, dispatch }, multipleSelection) {
			if (multipleSelection.length <= 0) {
                return Message.error('至少勾选一个采购需求');
			}
            await wait(dispatch, 'pcm.purchase.combineGenerateOrder', async function() {
                await carryOutDemandPlan({
                    purDemandSnList: multipleSelection.map((v) => {
                        return v.purDemandSn;
                    })
                });
                Message.success('操作成功');
            })
            dispatch('getList')
		}
    }
})



// WEBPACK FOOTER //
// ./src/store/modules/pcm/plan/list.js